
import { FootballRecord, ExcelRowData } from './types';
import { COLUMN_MAPPINGS, EXPECTED_COLUMNS } from './constants';

/**
 * Processes raw Excel data into a structured format for the application
 */
export const processExcelData = (jsonData: any[]): FootballRecord[] => {
  if (!jsonData || jsonData.length === 0) {
    console.log('No data to process');
    return [];
  }

  console.log('Raw Excel data:', jsonData);
  console.log('Number of columns in first row:', jsonData[0] ? Object.keys(jsonData[0]).length : 0);
  
  // Process data while maintaining original values exactly as they are
  const processedData = jsonData.map((row: any, index: number): FootballRecord => {
    // Create a base record with required fields
    const baseRecord: any = {
      id: index + 1,
      Date: '',
      Time: '',
      Division: '',
      HomeTeam: '',
      AwayTeam: '',
      FTHG: 0,
      FTAG: 0,
      FTR: '',
      HTHG: 0,
      HTAG: 0,
      HTR: '',
      Referee: '',
      HS: 0,
      AS: 0,
      HST: 0,
      AST: 0,
      HF: 0,
      AF: 0,
      HC: 0,
      AC: 0,
      HY: 0,
      AY: 0,
      HR: 0,
      AR: 0
    };

    // First, just copy all fields from the row to ensure we don't miss anything
    // This helps preserve all odds columns
    for (const key in row) {
      if (Object.prototype.hasOwnProperty.call(row, key)) {
        baseRecord[key] = row[key];
      }
    }

    // Now process the standard columns with special handling
    EXPECTED_COLUMNS.forEach(column => {
      const excelColumn = Object.entries(COLUMN_MAPPINGS)
        .find(([excel, db]) => db === column)?.[0] || column;

      let value = row[excelColumn] !== undefined ? row[excelColumn] : row[column];

      if (column === 'Date') {
        // CRITICAL: Preserve the exact date format from Excel - NO PROCESSING AT ALL
        if (value !== undefined && value !== null && value !== '') {
          const dateValue = String(value);
          console.log(`DataProcessor - Original date from Excel: "${dateValue}", type: ${typeof value}`);
          
          // Store exactly as received - no conversion, no formatting, nothing
          value = dateValue;
          
          console.log(`DataProcessor - Stored date: "${value}"`);
        } else {
          value = '';
        }
      }

      // Handle numeric fields - match stats
      if (['FTHG', 'FTAG', 'HTHG', 'HTAG', 'HS', 'AS', 'HST', 'AST', 'HF', 'AF', 'HC', 'AC', 'HY', 'AY', 'HR', 'AR'].includes(column)) {
        value = value !== undefined && value !== '' ? Number(value) : 0;
      }
      
      // Handle numeric fields - betting odds (all remaining numeric fields)
      if (column !== 'Date' && column !== 'Time' && column !== 'Division' && 
          column !== 'HomeTeam' && column !== 'AwayTeam' && column !== 'FTR' && 
          column !== 'HTR' && column !== 'Referee' && 
          !['FTHG', 'FTAG', 'HTHG', 'HTAG', 'HS', 'AS', 'HST', 'AST', 'HF', 'AF', 'HC', 'AC', 'HY', 'AY', 'HR', 'AR'].includes(column)) {
        if (value !== undefined && value !== '') {
          // Parse as float for odds
          const parsedValue = parseFloat(value);
          // Check if it's a valid number
          value = isNaN(parsedValue) ? undefined : parsedValue;
        } else {
          value = undefined; // Use undefined instead of 0 for missing odds
        }
      }

      // Only update if the value is defined
      if (value !== undefined) {
        baseRecord[column] = value;
      }
    });

    // Add additional logging to debug date issues
    if (baseRecord.Date) {
      console.log(`DataProcessor - Final date for ${baseRecord.HomeTeam} vs ${baseRecord.AwayTeam}: "${baseRecord.Date}"`);
    }

    return baseRecord as FootballRecord;
  });

  return processedData;
};

// Export everything from the constants file to maintain the same exports
export { EXPECTED_COLUMNS } from './constants';
